<template>
  <div id="app">
    <SFHeader/>
    <div v-if="getUserAuth != null">
      <Navbar/>
    </div>

    <div v-show="this.shouldShow">
      <banner v-bind:bannerURL="this.bannerURL"></banner>
      <!-- <banner v-if="this.bannerURL" :data="this.bannerURL"></banner> -->

      <pagenav></pagenav>
    </div>

    <router-view @bannerType="getBannerType"/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import pagenav from '@/components/pagenav'
import banner from '@/components/banner'
import {db, auth} from '@/firebase/init'
import SFHeader from '@/components/SFHeader'

export default {
  name: 'App',
  components: {
    Navbar,
    banner,
    pagenav,
    SFHeader,
  },
  meta: {
   title: "Knights of the Wandering Castle",
   icon:"@/assets/favicon.ico" 
  },
  data() {
      return {
          // defaultBannerURL: 'https://firebasestorage.googleapis.com/v0/b/luny-comics.appspot.com/o/banners%2Fdefault.png?alt=media&token=76194546-38bd-48a7-8359-a81f8d74e23d',
          bannerURL: null,
          user: null,
          routeName: null,
          noBannerPages: ['Login'], // route names of pages that should not show banner
          shouldShow: false
      }
  },
  computed: {
      getUserAuth() {
        return this.user;
      },
  },
  methods: {
    checkUserAuth() {
      this.user = auth.currentUser;
      // console.log("current user:" + auth.currentUser);
    },
    getCurrentRouteName() {
        return this.$route.name;
    },
    getShouldShow() {
      var routeName = this.getCurrentRouteName();
      // console.log("getShould " + routeName);
      if (this.noBannerPages.includes(routeName)) {
        this.shouldShow = false;
      } else {
        this.shouldShow = true;
      }
      // console.log("getShould " + this.shouldHide);
    },

    getBannerType(value){
      // console.log(value)
      if(value){
        this.bannerURL = value;
      }
    },
  },
  async mounted() {
    // console.log("App.vue: mounted");
    this.checkUserAuth();
    this.getShouldShow();
    // console.log(this.routeName);
  },
  beforeUpdate() {
    this.checkUserAuth();
    this.getShouldShow();
    // MUST CHANGE: unsecure redirect from pages needing login
    if(this.$route.meta.requiresAuth && this.user == null){
      this.$router.push({ name: 'Home' })
    }
    // will change to default banner when not in Comic/Home page
    if(this.$route.name != 'Comic-Page' && this.$route.name != 'Comic-Strip' && this.$route.name != 'Home'){
      db.collection("banners").doc("default").get().then((doc)=>{
        this.bannerURL = doc.data().url;
      })
    }
  },
};
</script>

<style>
@font-face{
	font-family: KnightsQuest;
	src: url('assets/Knights_Quest.ttf');
}

@font-face{
  font-family: Futura;
  src: url('assets/futur.otf');
}

#app {
  font-family: KnightsQuest, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-image: url("./assets/bg.png");
  background-repeat: repeat;
  background-color: #3A3347;
  color: #2c3e50;
  padding-top: 2%;
  padding-left: 18%;
  padding-right: 18%;
  padding-bottom: 5%;
  display: block;
  min-height: 100vh;
}
.bg-cover{
	background-size: 100% 100%;
}
.navbar{
	padding-left: auto;
  padding-right: auto;
  text-align: center;
}
.navbuttons{
  color: #FFFFFF;
  font-size: 3vw;
}
.navbuttons:hover{
  text-shadow: 0 0 20px #ffff00, 0 0 30px #FFD700;
  cursor: pointer;
}


@media (min-width: 600px) {
  /* For tablets: */
  .main{
    padding-top: 2%;
    padding-left: 5%;
    padding-right: 5%;
    padding-bottom: 5%;
    display: block;
    min-height: 100vh;
  }
}
@media (min-width: 768px) {
  /* For desktop: */
  .main{
    padding-top: 2%;
    padding-left: 18%;
    padding-right: 18%;
    padding-bottom: 5%;
    display: block;
    min-height: 100vh;
  }
}


</style>

